<template>
  <div class="customer-review-container">
    <v-card class="customer-review-card">
      <div class="review-header">
        <div class="customer-name-wrapper">
          <h2 class="customer-name">
            {{ name }}
          </h2>
          <div v-if="review.verified" class="customer-verified-wrapper">
            <img src="@/modules/lenders/assets/verified_check.svg" />
            <span>Verified</span>
          </div>
        </div>

        <StarRating
          :rating="review.scoreAverage"
          :editable="false" />
      </div>
      <div class="review-content">
        {{ message("review") }}
      </div>
      <div v-if="isTooLong('review')">
        <v-btn text depressed class="expand-btn" @click="toggleExpandReview()">
          {{ expandText("review") }}
        </v-btn>
      </div>
    </v-card>

    <v-card class="customer-response-card" v-if="review && review.responseFrom">
      <div class="response-content">
        <div class="response-from">
          Reply from {{ review.responseFrom }} of {{ lenderTitle }}
        </div>
        <div class="response-message">
          {{ message("response") }}
        </div>
        <div v-if="isTooLong('response')">
          <v-btn text depressed class="expand-btn" @click="toggleExpandResponse()">
            {{ expandText("response") }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Review',
  props: {
    review: Object,
    lenderTitle: String,
  },
  data: () => ({
    maxTextLength: 200,
    reviewExpanded: false,
    responseExpanded: false,
  }),
  computed: {
    name () {
      if (this.review.anonymous) return 'Anonymous'
      const { user } = this.review

      let name = this.review.clientName
      if (user.firstName && user.lastName) {
        name = `${user.firstName} ${user.lastName[0]}.`
      } else {
        const parts = user.fullName.split(' ')
        if (parts.length === 1) {
          name = user.fullName
        }

        if (parts.length > 1) {
          name = `${parts[0]} ${parts[parts.length - 1]}.`
        }
      }

      return name || 'Anonymous'
    },
  },
  methods: {
    isTooLong (type = 'review') {
      const { reviewDescription, responseMessage } = this.review
      if (type === 'review') return reviewDescription.length > this.maxTextLength
      if (type === 'response') return responseMessage.length > this.maxTextLength

      return false
    },
    message (type = 'review') {
      const field = type === 'review' ? 'reviewDescription' : 'responseMessage'

      return this.isTooLong(type) && !this[`${type}Expanded`]
        ? this.review[field].slice(0, this.maxTextLength) + '...'
        : this.review[field]
    },
    expandText (type = 'review') {
      return this[`${type}Expanded`] ? 'Read Less' : 'Read more'
    },
    toggleExpandReview () {
      this.reviewExpanded = !this.reviewExpanded
    },
    toggleExpandResponse () {
      this.responseExpanded = !this.responseExpanded
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-review-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  padding: 36px 0;

  font-family: "Sansation Regular", Serif;

  .v-card.customer-review-card {
    background-color: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }
}

.customer-review-card,
.customer-response-card {
  .review-header {
    display: flex;
    justify-content: space-between;

    margin-bottom: 10px;

    .customer-name-wrapper {
      display: flex;
      align-items: center;
    }

    .customer-name {
      margin-right: 2em;

      font-family: "Sansation Bold", Serif;
      font-size: 16px;
      line-height: 23px;
      letter-spacing: 0;
      color: #4e4e4e;
    }

    .customer-verified-wrapper {
      display: flex;
      align-items: center;

      font-size: 13px;
      line-height: 15px;
      color: #707070;

      img {
        width: 1.5em;
        margin-right: 0.5em;
      }
    }
  }

  .review-content,
  .response-content {
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0;
    color: #4e4e4e;
  }

  .expand-btn {
    height: auto;
    padding: 5px 0;

    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.56px;
    text-transform: none;
    color: #0096a6;
  }
}

.customer-review-card {
  width: 100%;
}

.customer-response-card {
  width: calc(100% - 20px);
  background-color: #e5e5e5;

  margin-top: 30px;
  padding: 10px;

  .response-from {
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>
